import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglass03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 2.4h14.4M4.8 21.6h14.4M17.4 2.4v2.925a3 3 0 0 1-.64 1.853l-3.01 3.832a1.8 1.8 0 0 0 .03 2.26l2.93 3.535a3 3 0 0 1 .69 1.915v2.88M6.6 2.4v2.925a3 3 0 0 0 .64 1.853l3.01 3.832a1.8 1.8 0 0 1-.03 2.26l-2.93 3.535a3 3 0 0 0-.69 1.915v2.88"
    />
  </svg>
);
export default SvgHourglass03;
